import React from "react";

import Modal from "../../../../components/elements/Modal";
import ManageMedia from "../ManageMedia";

const ManageMediaModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update One" : "Create New"}
    >
      <ManageMedia getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageMediaModal;
